import { render } from "./NextDateIcon.vue?vue&type=template&id=359c24ab"
import script from "./NextDateIcon.vue?vue&type=script&lang=js"
export * from "./NextDateIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__